import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-header">
            <h2>Contact Us</h2>
            <p className="contact-intro">
              Whether you're a student looking to build AI skills or a working professional seeking to upskill for career advancement, we're here to help you become industry-ready. Connect with our team to explore personalized learning pathways.
            </p>
          </div>

          <div className="contact-main">
            <div className="contact-info">
              <div className="info-section">
                <h3>Ready to Advance Your Career?</h3>
                <p className="info-description">
                  Connect with us to discuss how our AI training programs can help you achieve your professional goals, whether you're starting your career or looking to transition into AI roles.
                </p>
                <div className="contact-details">
                  <div className="contact-item">
                    <div className="contact-label">Address</div>
                    <div className="contact-value">
                      Global Sansys Pvt Ltd<br />
                      AP SEZ, Atchutapuram<br />
                      Visakhapatnam, Andhra Pradesh 531011
                    </div>
                  </div>
                  
                  <div className="contact-item">
                    <div className="contact-label">Phone</div>
                    <div className="contact-value">
                      <a href="tel:+918885635672">+91 8885635672</a><br />
                      <a href="tel:+917989029878">+91 7989029878</a>
                    </div>
                  </div>
                  
                  <div className="contact-item">
                    <div className="contact-label">Email</div>
                    <div className="contact-value">
                      <a href="mailto:globalsansys@gmail.com">globalsansys@gmail.com</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-cta">
              <div className="cta-content">
                <h3>Connect with Our Team</h3>
                <p>
                  Join thousands of students and professionals who have transformed their careers with our comprehensive AI training programs. 
                  From foundational concepts to advanced applications, we offer flexible learning paths designed for your schedule and career goals.
                </p>
                <div className="cta-actions">
                  <a href="tel:+918885635672" className="btn-primary">
                    Book Free Consultation
                  </a>
                  <a href="mailto:globalsansys@gmail.com" className="btn-secondary">
                    Get Course Details
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;